"use client";
import Link from "next/link";
import {
  Sheet,
  SheetTrigger,
  SheetContent,
  SheetClose,
} from "../components/ui/sheet";
import { usePathname } from "next/navigation";
import { CiMenuFries } from "react-icons/ci";
import { useTranslations } from "next-intl";
import LanguageSwitcher from "./LanguageSwitcher";
import NativeShareButton from "./NativeShareButton";

interface LinkItem {
  key: "home" | "skills" | "services" | "resume" | "work" | "contact";
  path: string;
}

const links: LinkItem[] = [
  { key: "home", path: "/" },
  { key: "skills", path: "/skills" },
  { key: "services", path: "/services" },
  { key: "resume", path: "/resume" },
  { key: "work", path: "/work" },
  { key: "contact", path: "/contact" },
];

const MobileNav = () => {
  const pathname = usePathname();
  const t = useTranslations("common.nav");
  return (
    <Sheet>
      <SheetTrigger className="flex justify-center items-start cursor-target">
        <CiMenuFries className="text-[32px] text-accent cursor-target" />
      </SheetTrigger>
      <SheetContent className="flex flex-col">
        <div className="mt-3 flex items-center justify-end gap-3">
          <NativeShareButton />
        </div>
        <nav className="mt-8 flex flex-col justify-center items-center gap-8">
          {links.map((link, index) => {
            return (
              <SheetClose asChild key={index}>
                <Link
                  href={link.path}
                  className={`text-xl capitalize hover:text-accent transition-all cursor-target ${
                    link.path === pathname &&
                    "text-accent border-b-2 border-accent"
                  }`}
                >
                  {t(link.key)}
                </Link>
              </SheetClose>
            );
          })}
        </nav>
        <div className="mt-8 flex justify-center">
          <LanguageSwitcher compact />
        </div>
      </SheetContent>
    </Sheet>
  );
};

export default MobileNav;
